import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { resetCookieConsentValue } from "react-cookie-consent";
import logo from "../assets/logo.png";

const handleResetCookies = (e) => {
  e.preventDefault();
  resetCookieConsentValue("bbs_cookie_consent");
  window.location.reload();
};

const Footer = () => {
  return (
    <Wrapper>
      <div className="signature-row">
        <span className="script">Bushman Bar Service</span>
      </div>

      <div className="gridBox">
        <div className="box brand">
          <img src={logo} alt="Bushman Bar Service" />
          <h6 className="bold">Bushman Bar Service s.r.o.</h6>
          <h6>Pardubice — Zelené Předměstí</h6>
          <h6>Pichlova 2532, PSČ 530 02</h6>
          <h6 className="ico">IČO: 09043250</h6>
        </div>

        <div className="box">
          <h4>Půjčovna</h4>
          <Link to="/pronajem-party-stanu-vybaveni" className="link">
            Produkty
          </Link>
          <Link to="/extra" className="link">
            Doplňkové služby
          </Link>
          <Link to="/extra" className="link">
            Ceník
          </Link>
        </div>

        <div className="box">
          <h4>Catering</h4>
          <Link to="/barovy-catering-na-akce" className="link">
            Služby
          </Link>
        </div>

        <div className="box">
          <h4>Kontakt</h4>
          <Link to="/about" className="link">
            Kontakt &amp; mapa
          </Link>
        </div>

        <div className="box">
          <h4>Informace</h4>
          <Link to="/info" className="link">
            Obchodní podmínky
          </Link>
          <Link to="/info" className="link">
            GDPR
          </Link>
          <a href="#" onClick={handleResetCookies} className="link">
            Cookies
          </a>
        </div>
      </div>

      <div className="copyright">
        © {new Date().getFullYear()} Bushman Bar Service s.r.o. · Všechna práva vyhrazena
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.footer`
  background: var(--clr-dark-1);
  color: var(--clr-cream);
  padding: 3rem 1.5rem 1.5rem;

  .signature-row {
    text-align: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    padding-bottom: 1.5rem;
    margin-bottom: 2.5rem;
    .script {
      font-family: var(--ff-script);
      color: var(--clr-accent-light);
      font-size: 2rem;
      font-weight: 700;
    }
  }

  .gridBox {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
    max-width: var(--max-width);
    margin: 0 auto;
  }

  .box {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .box h4 {
    font-family: var(--ff-display);
    font-size: 1.1rem;
    color: var(--clr-accent-light);
    margin-bottom: 0.25rem;
    text-transform: none;
    letter-spacing: 0.02em;
  }

  .box h6 {
    font-family: var(--ff-body);
    color: var(--clr-cream);
    font-weight: 400;
    font-size: 0.9rem;
    line-height: 1.5;
    margin: 0;
    text-transform: none;
    letter-spacing: 0;
  }
  .box h6.bold {
    font-weight: 600;
    font-size: 1rem;
  }
  .box h6.ico {
    color: var(--clr-charcoal-3);
    margin-top: 0.5rem;
  }

  .brand img {
    max-width: 110px;
    margin-bottom: 0.75rem;
  }

  .link {
    color: var(--clr-cream);
    text-decoration: none;
    font-size: 0.95rem;
    transition: color var(--transition);
    text-underline-offset: 4px;
    cursor: pointer;
  }
  .link:hover {
    color: var(--clr-accent-light);
    text-decoration: underline;
  }

  .copyright {
    max-width: var(--max-width);
    margin: 2.5rem auto 0;
    padding-top: 1.5rem;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    text-align: center;
    color: var(--clr-charcoal-3);
    font-size: 0.85rem;
  }

  @media (min-width: 520px) {
    padding: 3.5rem 2rem 1.5rem;
    .gridBox {
      grid-template-columns: repeat(2, 1fr);
      gap: 2.5rem;
    }
  }

  @media (min-width: 776px) {
    padding: 4rem 2rem 2rem;
    .gridBox {
      grid-template-columns: 1.4fr 1fr 1fr 1fr 1fr;
      gap: 3rem;
    }
  }
`;

export default Footer;
